import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { COURSES } from "@/data/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const FREE_SESSIONS_OPTION = "2 Free Sessions (Play First, Pay Later)";

export default function LeadForm({ defaultCourse = "General", source = "website", compact = false }) {
  const [form, setForm] = useState({ name: "", phone: "", course: defaultCourse, message: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim()) {
      toast.error("Please add your name and phone number");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/leads`, { ...form, source });
      setDone(true);
      toast.success("Request received! We'll call you back shortly.");
    } catch (err) {
      toast.error("Something went wrong. Please try WhatsApp instead.");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div className="rounded-2xl border border-teal/30 bg-teal/5 p-8 text-center" data-testid="lead-form-success">
        <p className="font-body font-extrabold text-xl text-teal">You're on the highway!</p>
        <p className="text-sm text-muted mt-2">Thanks {form.name.split(" ")[0]} - our team will reach out on {form.phone} to start your {form.course} journey.</p>
      </div>
    );
  }

  const inputCls = "w-full rounded-xl border border-ink/15 bg-white px-4 py-3 text-sm outline-none focus:border-brand focus:ring-2 focus:ring-brand/15 transition";

  return (
    <form onSubmit={submit} className={`grid gap-3 ${compact ? "" : "sm:grid-cols-2"}`} data-testid="lead-form">
      <input className={inputCls} placeholder="Your name *" value={form.name} onChange={set("name")} required data-testid="lead-form-name-input" aria-label="Your name" />
      <input className={inputCls} placeholder="Phone / WhatsApp number *" value={form.phone} onChange={set("phone")} required data-testid="lead-form-phone-input" aria-label="Phone number" inputMode="tel" />
      <select className={inputCls} value={form.course} onChange={set("course")} data-testid="lead-form-course-select" aria-label="Course of interest">
        <option value="General">I'm not sure yet</option>
        <option value={FREE_SESSIONS_OPTION}>{FREE_SESSIONS_OPTION}</option>
        {COURSES.map((c) => <option key={c.id} value={c.name}>{c.name}</option>)}
        {form.course && !["General", FREE_SESSIONS_OPTION, ...COURSES.map((c) => c.name)].includes(form.course) && (
          <option value={form.course}>{form.course}</option>
        )}
      </select>
      <input className={inputCls} placeholder="Anything we should know? (optional)" value={form.message} onChange={set("message")} data-testid="lead-form-message-input" aria-label="Message" />
      <button
        type="submit"
        disabled={loading}
        data-testid="lead-form-submit-button"
        className="sm:col-span-2 rounded-full bg-ink text-paper font-semibold text-sm py-3.5 hover:bg-brand transition-colors duration-300 disabled:opacity-60"
      >
        {loading ? "Sending..." : "Request a Callback"}
      </button>
    </form>
  );
}
